import {useSettingsQuery} from '../../../common/providers/ApiInterface'
import {useUrlParam} from '../../../routing'

export const useDefaultOperationTimesQuery = ({
  assetsIds,
  isDisabled = assetsIds.length === 0
}: {
  assetsIds: number[]
  isDisabled?: boolean
}) => {
  const plantCode = useUrlParam('plantCode')

  return useSettingsQuery('defaultAssetsOperationTimes', [{assetsIds, plantCode}], {
    enabled: !isDisabled
  })
}
